module.exports = __webpack_public_path__ + "9dc1d71150f7af04bac31222241d6942.png";